<template>
  <div class="tabs__item item_1">
    <!--
    <div class="tab__warning__container" v-if="loggedIn == 0 && isSafari">
      {{ $t("mainTab.safariWarningMessage") }}
    </div>
    -->
    <div class="tab__content">
      <div class="tab__content__title" v-if="loggedIn == 0">
        <p class="tab__content__title_large">{{ $t("mainTab.nonLoggedInBigHeading") }}</p>
        <!--<p class="tab__content__title_small">{{ $t("mainTab.nonLoggedInSmallHeadingLine1") }}</p>-->
        <p class="tab__content__title_small">{{ $t("mainTab.nonLoggedInSmallHeadingLine2") }}</p>
      </div>
      <div class="tab__content__title" v-if="loggedIn == 1">
        <p class="tab__content__title_large">{{ $t("mainTab.loggedInBigHeadingLine1") }}</p>
        <p class="tab__content__title_large" style="margin-bottom: 20px">{{ $t("mainTab.loggedInBigHeadingLine2") }}</p>
      </div>
      <div class="tab__content__active">
        <v-btn depressed
          color="#0cdbf6" class="button_blue button_big connect__btn clickme"
          v-on:click="connect" id="connect_btn" v-show="loggedIn == 0">
          {{ $t('mainTab.buttonJoinVcita') }}
        </v-btn>
        <p class="tab__content__title_small" v-show="loggedIn == 0">
          {{ $t("mainTab.buttonSignInBefore") }} <a href="#" v-on:click="signin" class="connect__btn">{{ $t("mainTab.buttonSignIn") }}</a>
        </p>
        <v-btn depressed
          color="#0cdbf6"
          class="button_blue button_big clickme"
          v-on:click="goToSettings"
          v-if="(config.paypal_email == '' || config.paypal_email == null || config.paypal_email.length < 3) && config.square_location_id == null && config.stripe_user_id == null"
          v-show="loggedIn == 1">
            {{ $t("mainTab.buttonConnectPaymentGateway") }}
          </v-btn>
        <p
          class="tab__content__title_large"
          v-if="loggedIn == 1 && ((config.paypal_email != '' && config.paypal_email != null && config.paypal_email.length >= 3) || config.square_location_id != null || config.stripe_user_id != null)">
          <b>{{ $t("mainTab.youAreConnectedToMessage") }}</b>
          <b v-if="config.paypal_email != '' && config.paypal_email != null && config.paypal_email.length >= 3" style="display:inline">&nbsp;Paypal</b>
          <b v-if="config.paypal_email != '' && config.paypal_email != null && config.paypal_email.length >= 3 && (config.square_location_id != null || config.stripe_user_id != null)" style="display:inline">&nbsp;&</b>
          <b v-if="config.stripe_user_id != null && config.stripe_user_id != ''" style="display:inline">&nbsp;Stripe</b>
          <b v-if="config.stripe_user_id != null && config.stripe_user_id != '' && config.square_location_id != '' && config.square_location_id != null" style="display:inline">
            &nbsp;/
          </b>
          <b v-if="config.square_location_id != null && config.square_location_id != ''" style="display:inline">&nbsp;Square</b>
        </p>
        <a href="#" class="button_white button_big" v-on:click="goToDesign" v-show="loggedIn == 1">{{ $t("mainTab.buttonCallToDesign") }}</a>
      </div>
    </div>
    <!--
    <div class="tabs__banner">
      <div class="banner2__container">
        <header>{{ $t("banners.banner2Header") }}</header>
        <div class="__mask"></div>
        <div class="__list">
          <ul>
            <li>{{ $t("banners.banner2List_1") }}</li>
            <li>{{ $t("banners.banner2List_2") }}</li>
            <li>{{ $t("banners.banner2List_3") }}</li>
          </ul>
          <ul>
            <li>{{ $t("banners.banner2List_4") }}</li>
            <li>{{ $t("banners.banner2List_5") }}</li>
          </ul>
        </div>
        <footer>
          <a href="#" @click="openUpgradePage">{{ $t("banners.learnMore") }}</a>
        </footer>
      </div>
    </div>
    -->
  </div>
</template>

<script>
import * as GA from '@/assets/js/ga.js'

export default {
  name: 'tabMain',
  props: ['loggedIn', 'pivotId', 'config', 'userData'],
  data () {
    return {
      isSafari: false
    }
  },
  methods: {
    connect: function () {
      GA.track('wixpay_join_vcita', {
        uid: null,
        page: 'Main'
      })

      this.$emit('login', true)
    },
    signin: function () {
      GA.track('wixpay_signin', {
        uid: null,
        page: 'Main'
      })

      this.$emit('login', false)
    },
    goToSettings: function () {
      GA.track('wixpay_configure_gateway', {
        uid: this.loggedIn ? this.userData.business_id : null
      })

      this.$emit('inputIndex', 1)
    },
    goToDesign: function () {
      GA.track('wixpay_design_button', {
        uid: this.loggedIn ? this.userData.business_id : null
      })

      this.$emit('inputIndex', 2)
    },
    openUpgradePage: function () {
      this.$emit('openUpgradePage')
    }
  },
  created () {
    if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
      this.isSafari = true
    }
  }
}
</script>
<style lang="scss">
@import '../assets/style/_tab_main.scss';
</style>
